import { Button } from 'components/button';

import styles from './sidebar-link.module.scss';

export interface ISidebarLinkProps {
	title?: string;
	href?: string;
	description?: string;
}

const SidebarLink = (props: ISidebarLinkProps): React.JSX.Element => {
	const { title, href, description } = props;

	return (
		<div className={styles.sidebarlink}>
			<Button title={title} variant="tertiary-dark" href={href} />
			{description && (
				<span id="description" className={styles.label}>
					{description}
				</span>
			)}
		</div>
	);
};

export { SidebarLink };
